// eslint-disable-next-line import/no-anonymous-default-export
export default [
  "AGS-VIR-036",
  "AGS-VIR-037",
  "AGS-VIR-038",
  "AGS-VIR-039",
  "AGS-VIR-040",
  "AGS-VIR-041",
];
